// 接收消息  传消息内容进来
let receiveMsgFn = {
	receiveMsg(message, type) {
		let chatType = message.type == 'chat' ? 'singleChat' : 'groupChat'
		var my = uni.getStorageSync("myUsername");
		if (chatType == 'groupChat' && message.from == my) {
			// 群聊不收自己发的消息
			// 如果是自定义Info消息就收
			if (message.customEvent == 'info') {

			} else {
				return
			}

		}
		let myInfo = getApp().globalData.userInfoFromServer
		let sessionId = ''
		if (chatType == 'groupChat') {
			sessionId = message.to
		} else {
			if (my > message.to) {
				sessionId = my + message.to
			} else {
				sessionId = message.to + my
			}
		}
		// //console.log('收到消息message处理', message)
		let msg = {
			"createTime": message.time,
			"id": message.id,
			"formUser": message.from,
			"toUser": chatType == 'singleChat' ? message.to : '',
			"toGroup": chatType == 'singleChat' ? '' : message.to,
			"type": type == 'txt' ? 'text' : 'custom',
			"customType": type == 'txt' ? 'text' : message.customEvent,
			"content": type == 'custom' ? message.customExts.content : message.data,
			"msgType": chatType == 'singleChat' ? '1' : '2',
			"messageId": message.id,
			"sessionId": sessionId,
			"fromUserName": '',
			"fromUserAvatar": '',
			"toUserName": chatType == 'singleChat' ? myInfo.nickName : '',
			"toUserAvatar": chatType == 'singleChat' ? myInfo.avatar : '',
			"businessFunction": message.ext && message.ext.businessFunction ? message.ext.businessFunction :
				null,
			"businessState": message.ext && message.ext.businessState ? message.ext.businessState : null,
			"businessId": null
		}

		uni.$emit('newMsgReceived', msg)
	}
}
export default receiveMsgFn